<template>
  <div>
    <Dialog :visible="visible" class="payment-redirect-dialog" style="width: 500px;" modal :closable="true" :dismissableMask="true" :draggable="false" @update:visible="cancelRedirectCountdown">
      <template #header>
        <div></div>
        <div class="payment-redirect-title">{{$t('checkout.payment_redirect.title')}}</div>
      </template>
      <div class="p-d-flex p-flex-column p-ai-center" style="gap: 20px; padding: 0 20px 20px;">
        <img src="assets/irinox/icons/payment_redirect.svg" width="120" alt="Payment Redirect"/>
        <div class="payment-redirect-message">{{$t('checkout.payment_redirect.subtitle')}}</div>
        <div class="p-d-flex p-jc-center p-ai-center p-mt-4" style="gap: 20px;">
          <Button severity="secondary" @click="cancelRedirectCountdown" :label="$t('checkout.payment_redirect.cancel')"></Button>
          <Button @click="stripeSessionInit()" :label="$t('checkout.payment_redirect.button') + ' (' + redirectCountdown + ')'"></Button>
        </div>
      </div>
      <template #footer>
        <div class="p-d-flex p-jc-center p-ai-center" style="gap: 20px;">
          <img src="assets/irinox/icons/powered_by_stripe.svg" width="120" alt="Powered by Stripe"/>
        </div>
      </template>
    </Dialog>

    <IrinoxDialogDark :visible="dialog.error" mode="error" :message="$t('details.dialog_error')" :life="3000"
      @update:visible="dialog.error = $event" />
  </div>
</template>

<script>
import IrinoxDialogDark from '../../IrinoxDialogDark.vue';
import PaymentService from '../../../service/PaymentService';
import { mapGetters } from 'vuex';

export default {
  emits: ['update:visible'],
  components: {
    IrinoxDialogDark
  },
  props: {
    visible: Boolean,
    appliance: Object,
    selectedPlan: Object
  },
  data() {
    return {
      redirectCountdown: 10,
      countdownInterval: null,
      dialog: {
        error: false
      }
    };
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken'
    })
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.redirectCountdown = 10;
        this.countdownInterval = setInterval(() => {
          this.redirectCountdown--;
          if (this.redirectCountdown <= 0) {
            this.stripeSessionInit();
          }
        }, 1000);
      } else {
        this.clearCountdown();
      }
    }
  },
  created() {
    this.paymentService = new PaymentService();
  },
  beforeUnmount() {
    this.clearCountdown();
  },
  methods: {
    clearCountdown() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
    },
    cancelRedirectCountdown() {
      this.clearCountdown();
      this.$emit('update:visible', false);
    },
    stripeSessionInit() {
      this.clearCountdown();
      this.$emit('update:visible', false);
      this.paymentService.createSessionSingle(
        this.personaltoken,
        [{ serialNumber: this.appliance.serialNumber, planId: this.selectedPlan.planId }],
        null,
        'PLANS',
        {}
      )
        .then((data) => {
          if (data.code == '200') {
            const sessionUrl = data.body.sessionUrl;
            if (!sessionUrl) {
              console.error('Missing Stripe sessionUrl in backend response', data);
              this.dialog.error = true;
              return;
            }
            window.location.href = sessionUrl;
          } else {
            console.error('EXCEPTION ' + JSON.stringify(data));
            this.dialog.error = true;
          }
        })
        .catch((error) => {
          console.error('EXCEPTION ' + error);
          this.dialog.error = true;
        });
    }
  }
};
</script>

<style scoped>
</style>
